<template>
    <div class="tabselector">
        <div class="tabspace">
            <div v-for="tab in tabs"
                 :class="'tab'+( tab.id === activeTab.id ? ' active' : '' )"
                 :key="tab.id"
                 @click="changeTab( tab )">
                {{ tab.label }}
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name : "TabSelector",
    emits: [ 'changeTab' ],
    props: {
        tabs: { Type: Array, required: true },
        tab : { Type: Object, required: false, default: {} }
    },
    data()
    {
        return {
            activeTab: false
        }
    },
    created()
    {
        this.activeTab = this.$props.tab || this.$props.tabs[ 0 ]
    },
    methods: {
        changeTab( tab )
        {
            this.activeTab = tab
            this.$emit( 'changeTab', tab )
        }
    }
}
</script>